export default "__VITE_ASSET__UexqfwsP__"